// i18n area 'hci' — locale no-NO (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.no-NO.meta.json.
import type { enUS } from './hci'

export const noNO: typeof enUS = {
  hci: {
    ceph: {
      title: 'Ceph-kluster',
      createButton: 'Opprett Ceph-kluster',
      emptyTitle: 'Ingen forvaltede Ceph-kluster',
      emptyBody: 'TVirt distribuerer og eier Ceph på medlemsnodene, hyperkonvergent med VM-lasten. Opprett et kluster: den første monitoren og manageren dens fødes automatisk på den valgte kontrollnoden — la det så vokse med flere monitorer og OSD-enheter.',
      pageTitle: 'Ceph-kluster',
      colState: 'Status',
      colMembers: 'Medlemmer',
      colSize: 'Størrelse',
      colVersion: 'Ceph-versjon',
      sizeCell: '{used} GiB brukt av {total} GiB totalt',
      phase: {
        'not-deployed': 'Ikke deployet',
        deploying: 'Deploy pågår',
        healthy: 'Frisk',
        degraded: 'Degradert',
        error: 'Feil',
        destroying: 'Destrueres',
        destroyed: 'Destruert'
      },
      health: {
        HEALTH_OK: 'Frisk (HEALTH_OK)',
        HEALTH_WARN: 'Med advarsler (HEALTH_WARN)',
        HEALTH_ERR: 'Med feil (HEALTH_ERR)',
        unknown: 'Ikke observert ennå',
        observedAt: 'observert {time}'
      },
      create: {
        title: 'Opprett Ceph-kluster',
        info: 'Når man oppretter et nytt Ceph-kluster må den første noden velges, der rollene MON og MGR blir installert. I tillegg må det angis hvilket subnett Ceph-trafikken skal gå i: public-subnettet brukes til generell nettverkstrafikk, mens kluster-subnettet brukes til de interne replikaene mellom OSD-ene; det trenger ikke nødvendigvis være forskjellige subnett.',
        controlNode: 'Kontrollnode',
        controlNodeHint: 'Medlemsnoden der første MON + MGR fødes.',
        publicSubnet: 'Public-subnett',
        publicSubnetHint: 'Et Subnett registrert i IPAM-en — Cephs public_network. Uforanderlig etter opprettelsen.',
        clusterSubnet: 'Kluster-subnett',
        clusterSubnetHint: 'Et Subnett registrert i IPAM-en — Cephs cluster_network (replika/backfill).',
        noSubnets: 'Ingen Subnett registrert — opprett dem først i IPAM-en',
        sameSubnet: 'Samme subnett for public- og kluster-trafikken',
        sameSubnetHint: 'Avkrysset = kluster-nettet (replika/backfill) faller sammen med public. Ikke avkrysset = velg subnettet dets OG kontrollnodens adresse inni det.',
        controlAddress: 'Kontrollnodens adresse',
        controlAddressHint: 'En adresse IPAM-en kjenner for noden innenfor public-subnettet.',
        controlClusterAddress: 'Kontrollnodens kluster-adresse',
        controlClusterAddressHint: 'En adresse IPAM-en kjenner for noden innenfor kluster-subnettet.',
        noAddresses: 'IPAM-en kjenner ingen adresser for denne noden innenfor det valgte subnettet',
        started: 'Kluster opprettet — bootstrappen fortsetter som macrotask; fasen oppdaterer seg selv',
        error: 'Klusteret ble avvist'
      },
      detail: {
        actions: 'Tilgjengelige handlinger',
        tabOverview: 'Oversikt',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Pooler',
        tabObjects: 'Objekter',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Avansert',
        phase: 'Fase',
        checksTitle: 'Aktive helsesjekker',
        noChecks: 'Ingen aktiv helsesjekk',
        checkMuted: 'dempet',
        summaryPools: 'Pooler',
        summaryFilesystems: 'Filsystemer',
        nodesCard: 'Noder',
        monHint: 'En MGR kjører kolokert med hver MON. Tre MON-er er det anbefalte quorumet; et lab-kluster starter med én. OSD-er og MDS-er lever i sine egne faner.',
        monHintSplit: 'MON og MGR er adskilt på dette klusteret (Avansert): hver rolle er et eget medlemskap per node. Tre MON-er er det anbefalte quorumet; minst én MGR må finnes.',
        noMons: 'Ingen monitor deklarert',
        addNode: 'Legg til node',
        removeNode: 'Fjern node',
        removeNodeFrom: 'Fjern noden {node} (dens MON og den kolokerte MGR-en)',
        roleMon: 'MON-rolle',
        roleMgr: 'MGR-rolle',
        roleNa: 'N/A',
        roleNotObserved: 'ikke observert ennå',
        monInQuorum: 'i quorum',
        monOutQuorum: 'utenfor quorum',
        mgrActive: 'aktiv',
        mgrStandby: 'standby',
        addRoleMon: 'Legg til MON-rolle',
        removeRoleMon: 'Fjern MON-rolle',
        addRoleMgr: 'Legg til MGR-rolle',
        removeRoleMgr: 'Fjern MGR-rolle',
        restartMon: 'Start MON-tjenesten på nytt',
        restartMgr: 'Start MGR-tjenesten på nytt',
        addMon: 'Legg til MON',
        removeMon: 'Fjern MON',
        removeMonFrom: 'Fjern MON-rollen fra {node}',
        addMgr: 'Legg til MGR',
        removeMgr: 'Fjern MGR',
        removeMgrFrom: 'Fjern MGR-rollen fra {node}',
        addMds: 'Legg til MDS',
        removeMds: 'Fjern MDS',
        removeMdsFrom: 'Fjern MDS-rollen fra {node}',
        mdsSection: 'Metadata server (MDS)',
        noMds: 'Ingen MDS deklarert — et filsystem krever først en',
        mdsHint: 'MDS-medlemskapet er sitt eget fra første dag: et kluster uten CephFS deklarerer ingen, én aktiv pluss én standby betjener et filsystem godt. Ceph velger aktive og standby blant de deklarerte daemonene.',
        mdsActiveFor: 'aktiv — {fs}',
        mdsNotObserved: 'ikke observert ennå',
        lastMdsGuard: 'Den siste MDS-en kan ikke fjernes så lenge et filsystem finnes — fjern filsystemene først',
        lastMonGuard: 'Den siste MON-en kan ikke fjernes — å destruere klusteret er den eneste utgangen',
        lastMgrGuard: 'Den siste MGR-en kan ikke fjernes — et forvaltet kluster kjører aldri uten manager',
        registerDevice: 'Legg til OSD',
        unregisterDevice: 'Avregistrer',
        activeDeviceGuard: 'Aktiv OSD — den går ut gjennom OSD-livssyklusen, ikke fra registeret',
        colNode: 'Node',
        devicePhase: { registered: 'Registrert', active: 'Aktiv' },
        health: 'Helse',
        state: 'Status',
        fsid: 'fsid',
        fsidPending: 'mangler — prøv bootstrappen på nytt',
        version: 'Ceph-versjon',
        publicNetwork: 'Public-nett',
        clusterNetwork: 'Kluster-nett',
        clusterNetworkCollapsed: '= public',
        noActions: 'Ingen handling tilgjengelig i denne fasen',
        destroyedNote: 'Kluster destruert — raden fjernes automatisk om litt'
      },
      overview: {
        services: 'Tjenester',
        ok: 'friske',
        warning: 'warning',
        down: 'nede',
        pgTitle: 'PG-tilstander',
        pgTotal: '{n} PG-er totalt',
        capacityTitle: 'Plass',
        ioTitle: 'Nåværende I/O',
        ioReadBw: 'Lesebåndbredde',
        ioWriteBw: 'Skrivebåndbredde',
        ioReadIops: 'Lese-IOPS',
        ioWriteIops: 'Skrive-IOPS',
        notObserved: 'ikke observert ennå'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Status',
        colSize: 'Størrelse',
        colPgs: 'PG',
        empty: 'Ingen OSD — legg til en fra en deklarert datadisk',
        markIn: 'Merk IN',
        markOut: 'Merk OUT',
        scrub: 'Kjør scrub',
        deepScrub: 'Kjør dyp scrub',
        restart: 'Start tjenesten på nytt',
        details: 'Detaljer',
        actionGuard: 'Bare på en aktiv OSD i et deployet kluster',
        inTitle: 'Merk OSD IN',
        inBody: 'osd.{id} går tilbake i datadistribusjonen (ceph osd in): Ceph rebalanserer data over på den.',
        outTitle: 'Merk OSD OUT',
        outBody: 'osd.{id} går ut av datadistribusjonen (ceph osd out): dataene dens rebalanseres andre steder og redundansen er REDUSERT mens backfillen kjører. Reversibelt når som helst med Merk IN.',
        scrubTitle: 'Planlegg scrub',
        scrubBody: 'En scrub av osd.{id} planlegges: mon-en køer den, og PG-tilstandene i de neste sweepene forteller utfallet.',
        deepScrubTitle: 'Planlegg dyp scrub',
        deepScrubBody: 'En dyp scrub av osd.{id} planlegges: varianten som verifiserer bytene — tyngre på I/O, samme mekanikk.',
        restartTitle: 'Start OSD-tjenesten på nytt',
        restartBody: 'osd.{id} stoppes og startes på nytt gjennom workerens supervisjon på noden sin.',
        started: 'Handling startet — observasjonen oppdaterer seg selv',
        error: 'OSD-handlingen ble avvist'
      },
      osdDetail: {
        title: 'OSD-detaljer',
        tabGeneral: 'Generelt',
        tabNetwork: 'Nettverk',
        tabDevices: 'Enheter',
        version: 'Versjon',
        hostname: 'Hostname',
        dataPath: 'OSD-datasti',
        objectStore: 'OSD object store',
        encrypted: 'Kryptert',
        yes: 'Ja',
        no: 'Nei',
        memory: 'Minnebruk (PSS)',
        pid: 'Process ID (PID)',
        front: 'Front-adresse (klienter & monitorer)',
        hbFront: 'Heartbeat-adresse front',
        back: 'Back-adresse (OSD)',
        hbBack: 'Heartbeat-adresse back',
        colDevice: 'Device',
        colType: 'Type',
        colPhysical: 'Fysisk device',
        colSize: 'Størrelse',
        volumeTitle: 'Volumdetaljer',
        creationTime: 'Opprettelsesdato',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Ingen device observert for denne OSD-en'
      },
      restart: {
        title: 'Start tjenesten på nytt',
        monBody: 'MON-daemonen på {node} stoppes og startes på nytt gjennom workerens supervisjon.',
        mgrBody: 'MGR-daemonen på {node} stoppes og startes på nytt gjennom workerens supervisjon.',
        started: 'Omstart startet — observasjonen oppdaterer seg selv',
        error: 'Omstarten ble avvist'
      },
      encryptionMode: {
        alwaysOn: 'Alltid aktivert (dmcrypt)',
        alwaysOff: 'Alltid deaktivert',
        perOsd: 'Valg per OSD',
        section: 'OSD-kryptering at rest',
        title: 'Endre OSD-krypteringsmodus',
        hint: 'Hvordan NYE OSD-er prepareres. Eksisterende OSD-er beholder sin per-disk-tilstand: for å endre den fjernes og gjenskapes OSD-en.',
        body: 'Modusen blir "{mode}" og gjelder BARE NYE OSD-er: hver eksisterende OSD beholder sin nåværende krypteringstilstand.',
        apply: 'Endre modus',
        error: 'Modusendringen ble avvist'
      },
      pin: {
        address: 'Public-adresse (valgfri pin)',
        clusterAddress: 'Kluster-adresse (valgfri pin)',
        autoPlaceholder: 'automatisk i subnettet {cidr}',
        hint: 'Adressering per daemon: tomt = Ceph fester seg selv innenfor det deklarerte nettet; utfylt = denne instansen pinnes til adressen i sin conf-seksjon.'
      },
      addMon: {
        title: 'Legg til node',
        node: 'Node',
        address: 'Public-adresse',
        addressHint: 'Nodens adresser som IPAM-en kjenner innenfor public-subnettet — automatisk når en eksisterende deklarasjon dekker noden.',
        clusterAddress: 'Kluster-adresse',
        clusterAddressHint: 'Obligatorisk: kluster-subnettet er separat og noden er ikke deklarert der ennå.',
        noAddresses: 'IPAM-en kjenner ingen adresser for denne noden innenfor subnettet',
        error: 'Tillegget av mon-en ble avvist'
      },
      removeMon: {
        title: 'Fjern MON',
        body: 'MON-en og dens kolokerte MGR forlater noden {node}. På et deployet kluster stoppes daemonene og fjernes fra quorumet.',
        error: 'Fjerningen av MON-en ble avvist'
      },
      addMgr: {
        title: 'Legg til MGR',
        node: 'Node',
        hint: 'Avansert (adskilte MON/MGR): en frittstående manager fødes på den valgte medlemsnoden med en node-affin task. Cephs active/standby-valg velger selv den aktive MGR-en.',
        error: 'Tillegget av MGR-en ble avvist'
      },
      removeMgr: {
        title: 'Fjern MGR',
        body: 'Den frittstående MGR-en forlater noden {node}. På et deployet kluster stoppes daemonen og tilstanden dens fjernes; nodens MON (om den finnes) røres ikke.',
        error: 'Fjerningen av MGR-en ble avvist'
      },
      addMds: {
        title: 'Legg til MDS',
        node: 'Node',
        hint: 'CephFS-ens metadata server: den fødes på den valgte medlemsnoden med en node-affin task, supervisert av workeren som MON og MGR. Ceph velger selv aktive og standby — én aktiv pluss én standby betjener et filsystem godt.',
        error: 'Tillegget av MDS-en ble avvist'
      },
      removeMds: {
        title: 'Fjern MDS',
        body: 'MDS-en forlater noden {node}. På et deployet kluster stoppes daemonen og tilstanden dens fjernes; API-et avviser den siste MDS-en så lenge et filsystem trenger den.',
        error: 'Fjerningen av MDS-en ble avvist'
      },
      split: {
        title: 'Adskilte MON/MGR',
        label: 'Tillat MON og MGR på adskilte noder',
        hint: 'Av (default) = den ratifiserte standarden: en MGR kjører kolokert med hver MON, ett enkelt medlemskap. På = MGR-medlemskapet blir sitt eget, forvaltet med handlingene Legg til/Fjern MGR i fanen Forvaltningsnoder.',
        enable: 'Aktiver',
        disable: 'Deaktiver',
        enableBody: 'MGR-medlemskapet blir uavhengig av MON-ene, initialisert fra den nåværende kolokeringen. Handlingene Legg til/Fjern MGR armeres i fanen Forvaltningsnoder. Dette slakker plattform-defaulten — behold det bare hvis du vet hvorfor du trenger det.',
        disableBody: 'Tilbake til standard kolokering: en MGR med hver MON, ett enkelt medlemskap. Lovlig bare hvis MGR-medlemskapet allerede faller sammen med MON-ene — juster det først med Legg til/Fjern MGR, ellers avviser API-et.',
        error: 'Endringen ble avvist'
      },
      rawEditor: {
        title: 'Rå CRUSH-editor',
        label: 'Vis den rå editoren for crushmapen i CRUSH-fanen',
        hint: 'Av (default) = den veiledede regelflaten er standardverktøyet. På = CRUSH-fanen viser også den dekompilerte crushmapen som redigerbar tekst. Lagringen krever alltid sudo, klusternavnet som bekreftelse, og går gjennom compile + test i crushtool FØR den når klusteret.'
      },
      osdFlags: {
        section: 'Globale OSD-flagg',
        title: 'OSD-flagg-override',
        notObserved: 'ikke observert ennå',
        standardFlowsHint: 'Plattformens standardflyter håndterer disse flaggene selv i de normale tilfellene (vedlikehold av en node setter en målrettet noout, diskbytte går gjennom OSD-livssyklusen). Denne seksjonen er den manuelle overriden for operatøren som vet hva de gjør.',
        notDeployedGuard: 'OSD-flagg finnes bare på et deployet kluster',
        set: 'Sett flagg',
        unset: 'Fjern flagg',
        setBody: 'Det globale flagget {flag} blir SATT på osdmapen. Det står til det fjernes eksplisitt — et glemt flagg degraderer klusterets selvreparasjon.',
        unsetBody: 'Det globale flagget {flag} blir FJERNET fra osdmapen.',
        error: 'Flaggendringen ble avvist',
        flag: {
          noout: 'Ingen OSD merkes out av datadistribusjonen — ingen rebalansering når en daemon går tapt',
          norebalance: 'Rebalanseringen av data er suspendert',
          nobackfill: 'Backfillen er suspendert',
          norecover: 'Recoveryen er suspendert',
          pause: 'ALL klient-I/O er pauset (lesinger og skrivinger)',
          noin: 'OSD-er som starter merkes ikke in automatisk',
          nodown: 'Utilgjengelige OSD-er merkes ikke down — maskerer reelle feil'
        }
      },
      pools: {
        section: 'Pooler',
        create: 'Opprett pool',
        createGuard: 'Pooler finnes bare på et deployet kluster',
        notObserved: 'Ingen observasjon av poolene — mon-sweepen rapporterer hit',
        empty: 'Ingen pool på klusteret',
        colName: 'Navn',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Application',
        colRule: 'CRUSH-regel',
        colUsage: 'Bruk',
        observedAtLabel: 'Observert',
        objects: '{n} objekter',
        inUseBy: 'i bruk av {name}',
        internalGuard: 'Intern Ceph-pool — plattformen sletter den aldri',
        delete: 'Slett pool',
        deleteGuard: 'Konsumert av storagen {name} — slett storagen først',
        hint: 'Bare replikerte pooler (erasure coding utenfor scope i v1). Replikaen lever i Ceph: denne tabellen er sannheten observert av mon-sweepen.',
        createTitle: 'Opprett pool',
        createHint: 'Poolen fødes på klusteret med den forespurte replikaen og applicationen rbd aktivert — jobben gjøres av en task på en MON-node. Slå på "Foreslå som storage" for å konsumere den med en gang i samme gest.',
        name: 'Poolnavn',
        nameHint: 'DNS-safe (små bokstaver, sifre, bindestreker).',
        size: 'Replikaer (size)',
        sizeHint: 'Kopier av hvert objekt. Default 3.',
        minSize: 'Minimum replikaer (min_size)',
        minSizeHint: 'Minimum kopier for å betjene I/O — følger size − 1 til du endrer den.',
        createError: 'Opprettelsen av poolen ble avvist',
        deleteTitle: 'Slett pool',
        deleteBody: 'Poolen {pool} og HVERT objekt i den destrueres irreversibelt. Skriv poolens navn for å bekrefte.',
        confirmLabel: 'Poolnavn',
        confirmHint: 'Skriv poolens navn for å bekrefte',
        deleteError: 'Slettingen av poolen ble avvist',
        detailTitle: 'Pool-detaljer',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Aktiv',
        autoscalerOff: 'Ikke aktiv',
        autoscalerWarn: 'Varsling',
        pgNumLabel: 'Antall PG-er',
        pgNumCaption: 'Observert: autoscaleren kan endre det på egen hånd — dette feltet skriver et ønske.',
        storage: 'Tilknyttet TVirt-storage',
        addAsStorage: 'Legg til som TVirt-storage',
        ruleSudoHint: 'Bytte av CRUSH-regel krever operatørpassordet.',
        updateError: 'Endringen av poolen ble avvist',
        updated: 'Poolendring startet — observasjonen oppdaterer seg selv'
      },
      crush: {
        section: 'CRUSH-regler',
        notObserved: 'Ingen CRUSH-observasjon ennå — mon-sweepen rapporterer hit',
        empty: 'Ingen regel observert på klusteret',
        hint: 'En regel avgjør HVOR kopiene av hvert objekt havner — dens feildomene er enheten som kan feile uten å miste data. Poolene peker på en regel; den innebygde replicated_rule (én replika per server) er fødsels-defaulten.',
        create: 'Opprett regel',
        createGuard: 'CRUSH-regler finnes bare på et deployet kluster',
        createTitle: 'Opprett CRUSH-regel',
        createHint: 'En regel = et valg av feildomene. Regelen fødes replikert på default-rooten — jobben gjøres av en task på en MON-node; knytt poolene til fra Pool-fanen etterpå.',
        createError: 'Opprettelsen av regelen ble avvist',
        name: 'Regelnavn',
        nameHint: 'DNS-safe (små bokstaver, sifre, bindestreker).',
        domain: 'Feildomene',
        domainChoice: {
          osd: 'Hver replika på en forskjellig OSD',
          host: 'Hver replika på en forskjellig server',
          rack: 'Hver replika i et forskjellig rack'
        },
        domainCustom: 'Tilpasset (steps skrevet for hånd)',
        domainOther: 'Hver replika i en forskjellig {type}',
        rackGuardHint: 'Ingen rack-bucket finnes i det observerte hierarkiet: regelen kan opprettes likevel, men ingen pool kan peke på den før et rack er deklarert i plasseringen av medlemsserverne (nodens innstillinger) — realignment-tasken bygger bucketen og tilknytningen åpner seg selv.',
        treeTitle: 'Observert hierarki',
        treeNotObserved: 'Ingen observasjon av hierarkiet — mon-sweepen rapporterer hit',
        treeOsds: '{n} OSD-er',
        treeHint: 'CRUSH-kartet slik klusteret ser det: root → deklarerte nivåer → servere (host) → OSD-er. Topologien følger hver servers deklarerte plassering (nodens innstillinger) — et posisjonsbytte realigner den via task.',
        unplacedWarning: 'Medlemmer uten deklarert posisjon: {nodes} — hostene deres blir stående rett under rooten, utenfor den deklarerte topologien. Deklarer posisjonen i nodens innstillinger (en advarsel, aldri en blokkering).',
        colName: 'Navn',
        colDomain: 'Feildomene',
        colPools: 'Pooler',
        builtinChip: 'builtin',
        builtinGuard: 'Klusterets default-regel — plattformen sletter den aldri',
        detailAction: 'Regeldetalj',
        detailType: 'Type',
        backToRules: 'Regler',
        ruleNotObserved: 'Den observerte regellisten nevner ikke denne regelen',
        noPools: 'Ingen pool rir på denne regelen',
        delete: 'Slett regel',
        deleteTitle: 'Slett CRUSH-regel',
        deleteBody: 'Regelen {rule} fjernes fra klusterets crushmap. Ingen pool må ri på den. Skriv regelens navn for å bekrefte.',
        deleteGuard: 'Ridd av poolen {name} — pek poolen om først',
        confirmLabel: 'Regelnavn',
        confirmHint: 'Skriv regelens navn for å bekrefte',
        deleteError: 'Slettingen av regelen ble avvist',
        changeRule: 'Bytt CRUSH-regel',
        changeRuleTitle: 'Bytt CRUSH-regel',
        changeRuleHint: 'Poolen begynner å plassere objektene sine etter den valgte regelen — Ceph flytter eksisterende data for å innrette seg (på en full pool følger en rebalansering).',
        changeRuleError: 'Regelbyttet ble avvist',
        rule: 'CRUSH-regel',
        rawTitle: 'Rå crushmap (dekompilert)',
        rawWarning: 'FARE: denne teksten er HELE klusterets plasseringspolitikk. En feilaktig crushmap kan ødelegge placementen for alle poolene samtidig. Lagringen kompilerer og tester crushmapen med crushtool FØR den injiseres — men en gyldig crushmap kan likevel være en dårlig idé.',
        rawReload: 'Last inn på nytt',
        rawLoading: 'Query i flukt — en read-only task dekompilerer crushmapen…',
        rawSave: 'Lagre crushmap',
        rawSaveTitle: 'Injiser crushmap',
        rawSaveBody: 'Den endrede teksten erstatter crushmapen for HELE klusteret etter compile + test i crushtool. Skriv klusterets navn for å bekrefte.',
        rawConfirmLabel: 'Klusternavn',
        rawConfirmHint: 'Skriv {name} for å bekrefte',
        rawError: 'Operasjonen på crushmapen mislyktes',
        rawHint: 'Teksten er crushtool -d-formen. Kompilerings- og testfeil kommer tilbake ord for ord fra crushtool — crushmapen når ikke klusteret hvis en av de to portene feiler.'
      },
      objects: {
        poolsSection: 'Objektutforsker',
        poolsHint: 'Velg en pool for å liste RBD-bildene dens. Hver dyp lesing kjører som read-only task på en MON-node — den blokkerer ikke (og blokkeres ikke av) de reelle operasjonene.',
        deployedGuard: 'Objekt-queryene svarer bare på et deployet kluster',
        browse: 'Bla i objektene',
        detailAction: 'Bildedetalj',
        backToPools: 'Pooler',
        backToImages: 'Bilder',
        refresh: 'Oppdater',
        loading: 'Query i flukt — en read-only task spør klusteret…',
        error: 'Queryen mislyktes',
        retry: 'Prøv igjen',
        notRbd: 'Pool med application "{app}" — den inneholder ingen RBD-bilder, ingenting å utforske her',
        noImages: 'Ingen RBD-bilder i denne poolen',
        colImage: 'Bilde',
        colSize: 'Størrelse',
        colObjects: 'Objekter',
        colSnapshots: 'Snapshots',
        imagesHint: 'Diskene på en konsumerende rbd-storage er bilder med navnet til disk-id-en sin. Objekttellingen er det provisjonerte (størrelse / objektstørrelse) — den reelle bruken lever i bildedetaljen.',
        infoTitle: 'Bilde',
        infoSize: 'Virtuell størrelse',
        infoObjects: 'Objekter (provisioned)',
        infoObjectSize: 'Objektstørrelse',
        infoPrefix: 'Objektprefiks',
        infoFormat: 'Format',
        infoFeatures: 'Features',
        usageTitle: 'Reell bruk (rbd du)',
        usageOf: 'av {provisioned} GiB provisioned',
        usageHint: 'Thin av natur: bare skrevne objekter opptar byte.',
        watchersTitle: 'Watchere',
        noWatchers: 'Ingen watcher — ingen har dette bildet åpent nå',
        snapshotsTitle: 'RBD-snapshots',
        noSnapshots: 'Ingen RBD-snapshot på dette bildet',
        colSnapshot: 'Snapshot',
        colProtected: 'Beskyttet',
        colTimestamp: 'Opprettet',
        protected: 'beskyttet',
        mappingTitle: 'Fysisk mapping (OSD-sett)',
        mappingSampled: 'Utvalg på {sampled} av {total} objekter — ærlig oppsummering: for store bilder konvergerer settet mot ALLE OSD-ene i poolen (CRUSH sprer objektene over hele poolen).',
        mappingComplete: 'Alle objektene mappet ({total} av {total}).',
        objectQueryTitle: 'Mapp et enkelt objekt',
        objectName: 'Objektnavn',
        objectHint: 'RADOS-objektnavn er <prefiks>.<16-hex-indeks> — ceph osd map svarer med PG og OSD-tripler.',
        mapObject: 'Mapp',
        primary: 'primær: osd.{osd}'
      },
      registerDevice: {
        title: 'Registrer OSD-enhet',
        hint: 'På et levende kluster PREPARERER registreringen også enheten: den blir en BlueStore-OSD med en automatisk node-affin task (aldri tom, ratifisert 2026-07-24). En enhet tilhører maks ett Ceph-kluster i hele flåten.',
        disk: 'Datadisk',
        diskHint: 'Nodens deklarerte datadisker — navn og serienummer',
        noDeclared: 'Ingen deklarert datadisk på denne noden — merk dem først i nodens lokale innstillinger',
        serialHint: 'Enhetens serienummer — identitetspinnen',
        encrypted: 'Krypter denne OSD-en (dmcrypt)',
        encryptedHint: 'Per-OSD-valget (klusterets modus er "valg per OSD"): det fryses på denne disken ved registreringen — et senere modusbytte omskriver det aldri; det gjør rad-handlingen krypter/dekrypter.',
        error: 'Registreringen ble avvist'
      },
      unregisterDevice: {
        title: 'Avregistrer enhet',
        body: 'Bare register: {name} slutter å være en OSD-kandidat for dette klusteret. Bytene dens røres ikke.',
        error: 'Avregistreringen ble avvist'
      },
      deploy: {
        action: 'Prøv deploy på nytt',
        title: 'Prøv bootstrappen på nytt',
        body: 'Fødsels-bootstrappen starter om igjen fra den nåværende konfigurasjonen: mon-ene starter, hver registrerte enhet prepareres og aktiveres som BlueStore-OSD. Operasjonen kjører som macrotask — fasen oppdaterer seg selv.',
        started: 'Bootstrap startet — fortsetter som macrotask; fasen oppdaterer seg selv',
        error: 'Bootstrappen ble avvist'
      },
      propose: {
        action: 'Foreslå som storage',
        title: 'Foreslå som storage',
        hintPool: 'Den eksisterende poolen {name} blir en TVirt-storage: en cephx-identitet begrenset til poolen havner i keystoren og ceph-rbd-storagen fødes klar. Forslaget konsumerer poolen — det oppretter aldri en.',
        hintFs: 'Det eksisterende filsystemet {name} blir en TVirt-storage: en cephx-identitet begrenset til filsystemet havner i keystoren og cephfs-storagen fødes klar og montert. Forslaget konsumerer filsystemet — det oppretter aldri et.',
        name: 'Storagenavn',
        nameHint: 'DNS-1123, unikt i scopen — cephx-identiteten tar navnet sitt fra den.',
        path: 'Path inni filsystemet',
        pathHint: 'Absolutt path inni filsystemet storagen monterer — / hvis du er i tvil.',
        alsoPropose: 'Foreslå som storage med en gang',
        alsoProposePoolHint: 'Etter opprettelsen foreslår samme gest den nyfødte poolen som ceph-rbd-storage — to eksplisitte kall, én enkelt dialog.',
        alsoProposeFsHint: 'Etter opprettelsen foreslår samme gest det nyfødte filsystemet som cephfs-storage — to eksplisitte kall, én enkelt dialog.',
        guard: 'Foreslå som storage — bare på et healthy kluster',
        started: 'Forslaget akseptert — storagen materialiserer seg; du finner den under Storage',
        submit: 'Opprett storage',
        error: 'Forslaget ble avvist'
      },
      fs: {
        section: 'Filsystemer',
        create: 'Opprett filsystem',
        createGuard: 'Filsystemer finnes bare på et deployet kluster',
        mdsFirstGuard: 'Legg til en MDS først — et filsystem uten metadata server fødes ubrukelig',
        notObserved: 'Ingen observasjon av filsystemene — MON-sweepen rapporterer hit',
        empty: 'Ingen filsystem på klusteret',
        colName: 'Navn',
        colPools: 'Pooler',
        colMds: 'MDS',
        noActiveMds: 'ingen aktiv MDS',
        delete: 'Fjern filsystem',
        deleteGuard: 'Konsumert av storagen {name} — slett storagen først',
        hint: 'Et filsystem eier sine data- og metadata-pooler (cephfs.<navn>.data / .meta): de fødes med det og dør med det — removeFs, aldri en manuell pool-sletting. Denne tabellen er sannheten observert av MON-sweepen.',
        createTitle: 'Opprett filsystem',
        createHint: 'Filsystemet fødes på klusteret med sine to pooler (application cephfs) og betjenes av de deklarerte MDS-ene — jobben gjøres av en task på en MON-node. Slå på "Foreslå som storage" for å konsumere det med en gang i samme gest.',
        name: 'Filsystemnavn',
        nameHint: 'DNS-safe (små bokstaver, sifre, bindestreker).',
        sizeHint: 'Replikaer for BEGGE de nyfødte poolene. Default 3.',
        createError: 'Opprettelsen av filsystemet ble avvist',
        deleteTitle: 'Fjern filsystem',
        deleteBody: 'Filsystemet {fs} og HVER fil i det destrueres irreversibelt — dets data- og metadata-pooler dør med det. Skriv filsystemets navn for å bekrefte.',
        confirmLabel: 'Filsystemnavn',
        confirmHint: 'Skriv filsystemets navn for å bekrefte',
        deleteError: 'Fjerningen av filsystemet ble avvist'
      },
      destroy: {
        action: 'Destruer',
        retryAction: 'Prøv slettingen på nytt',
        retryGuard: 'Destruksjonen kjører — retry gjelder en mislykket destruksjon (leasen avviser ellers)',
        title: 'Destruer klusteret',
        body: 'Den deployede fabricen demonteres: hver daemon i dette klusteret stopper, systemtilstanden dens og nøklene i keystoren frigis. Ved vellykket destruksjon fjernes klusteret automatisk.',
        confirmLabel: 'Klusternavn',
        confirmHint: 'Skriv klusterets navn for å bekrefte',
        wipe: 'Slett de registrerte enhetene',
        wipeHint: 'Avkrysset: signaturene på hver registrerte enhet slettes — dataene oppå er destruert. Ikke avkrysset: bytene forblir intakte og enhetene går tilbake til registrert.',
        guard: 'Destruer — ingenting deployet',
        started: 'Destruksjon startet — fortsetter som macrotask; fasen oppdaterer seg selv',
        error: 'Destruksjonen ble avvist'
      },
      delete: {
        guard: 'Slett — bare en ikke-deployet konfigurasjon (destruer først)',
        title: 'Slette {name}?',
        body: 'Konfigurasjonen og enhetsregisteret dens fjernes. Lovlig bare så lenge ingenting er deployet.',
        error: 'Slettingen ble avvist'
      }
    }
  }
}
